import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const initialState = {
  step: 'process',
  errorAlreadyActivated: true,
  selectedOption: {},
  activatedSimBeforeDelivery: true
}

const SubstituteSimCardModule = {
  namespaced: true,
  state: initialState,
  actions: {
    async orderSubstituteSimCard ({ commit, state, getters, rootGetters }, { nextStep }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation simOrder ($substituteSimCardInput: SubstituteSimCardInput!) {
          substituteSimCard (substituteSimCardInput: $substituteSimCardInput) {
            success
          }
        }`,
        variables: {
          substituteSimCardInput: {
            substituteSimCardProcess: 'SUMS',
            productNumber: state.selectedOption.productNumber,
            activateByCustomer: !state.activatedSimBeforeDelivery
          }
        }
      }).then((response) => {
        commit('Transaction/removeTransactionId', 'substituteSimCard', { root: true })
        commit('substituteSimCard/changeStep', { step: nextStep }, { root: true })
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async activateSim ({ commit, state, getters, rootGetters }, { nextStep }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation activateSimCard {
          activateSubstituteSimCard{success}
        }`
      }).then((response) => {
        commit('Transaction/removeTransactionId', 'substituteSimCard', { root: true })
        commit('substituteSimCard/changeStep', { step: nextStep }, { root: true })
      }).catch((error) => {
        splitError(error).forEach(e => {
          if (e.extensions.sums_code === 250) {
            commit('substituteSimCard/changeStep', { step: nextStep }, { root: true })
            commit('substituteSimCard/setErrorAlreadyActivated', { errorAlreadyActivated: false }, { root: true })
          } else {
            commit('addError', e, { root: true })
          }
        })
      })
    }
  },
  mutations: {
    changeStep (state, { step }) {
      state.step = step
    },
    setErrorAlreadyActivated (state, { errorAlreadyActivated }) {
      state.errorAlreadyActivated = errorAlreadyActivated
    },
    setSelected (state, { option, activatedSimBeforeDelivery }) {
      state.selectedOption = option
      state.activatedSimBeforeDelivery = activatedSimBeforeDelivery
    }
  },
  getters: {
    currentStep: state => state.step,
    isErrorAlreadyActivated: state => state.errorAlreadyActivated,
    selected: state => state.selectedOption,
    isActivatedBeforeDelivery: state => state.activatedSimBeforeDelivery
  }
}

export {
  SubstituteSimCardModule
}
